import { MatExpansionModule } from '@angular/material/expansion';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared.module';
import { FaqsSectionComponent } from './component';


const components = [
  FaqsSectionComponent,
];

@NgModule({
  declarations: [
    ...components,
  ],
  imports: [
    SharedModule,
    MatExpansionModule,
  ],
  exports: [
    ...components,
  ],
})
export class FaqsSectionModule { }
